module.exports = __webpack_public_path__ + "static/FY2021_HSE_press_release-aba829407a9685ae8bdb29502d08d6a1.pdf";